export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const currentUser = initialState?.currentUser;
  const roleCode = currentUser?.roleCode;
  const isAdmin = roleCode === 'GUANLIYUAN';
  const isProjectGroup = roleCode === 'XIANGMUZU';
  const canViewWorkspace = Boolean(currentUser) && (isAdmin || isProjectGroup);
  const canViewBiddings = Boolean(currentUser) && (isAdmin || isProjectGroup);
  const canViewDelivery = Boolean(currentUser) && (isAdmin || isProjectGroup);
  const canViewClients = Boolean(currentUser) && (isAdmin || isProjectGroup);
  const canViewNotifications = Boolean(currentUser) && (isAdmin || isProjectGroup);
  const canViewExpertSourcing = Boolean(currentUser) && (isAdmin || isProjectGroup);

  return {
    canAdmin: isAdmin,
    canProjectGroup: isProjectGroup,
    canViewWorkspace,
    canViewBiddings,
    canViewDelivery,
    canViewClients,
    canViewNotifications,
    canViewExpertSourcing,
    canViewBizOps: Boolean(currentUser),
  };
}
